var $ = jQuery;

$(".js-mcl-section-show-more-cta").click(function (e) {

    e.preventDefault();
    var $currButton = $(this);

    if ($currButton.hasClass('disabled')) return false;

    currCategory = $(this).data("category");

    data = {
        'action': 'paginated_elements',
        'post_type': $(this).data("post-type"),
        'page': $(this).data("pages")
    };

    var posting = $.post(ajax.baseUrl, data);

    $(this).addClass('light');

    posting.done(function (data) {
        jsondata = $.parseJSON(data);
        $(jsondata.markup).insertBefore($(".mcl-section-show-more .clearfix"));
        if (jsondata.has_next_page) {
            $currButton.data("pages", $currButton.data("pages") + 1);
        }
        else {
            $currButton.addClass('disabled');
        }
    }).always(function () {
        $currButton.removeClass('light');
    });

});


// WEBPACK FOOTER //
// ./src/components/templates/section-show-more/section-show-more.js